import ABCyaPhaser from "@abcya/abcya_phaser";
import ABCyaLib from "@abcya/abcya_lib";
import FontKeys from "../../FontKeys";

export function CreateHelpMessage(Scene,Tab)
{
    // if(!Scene.HelpPopUp && Scene.ActiveTree)
    // {
    //     //console.log("First");
    //     Tab = "First";
    //     Scene.HelpPopUp = true;
    // }
    //const TabList = ['Trees','Grlnd','Lts','Orn','TreTpr','Gfts'];
    const CleanUp = Scene.add.container(686,111);
    const HelpPopUp = Scene.addImage(0,0,"Hlp_Popup",CleanUp);
    const HelpPopupHeader = ABCyaPhaser.Text.addText(-231,-91,24, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("help_popup_header"), CleanUp, false).setOrigin(0);

    if(Scene.CleanUpHelp)
    {
        Scene.CleanUpHelp.removeAll(true);
        Scene.CleanUpHelp.destroy();
        Scene.CleanUpHelp = CleanUp;
    }
    else
    {
        Scene.CleanUpHelp = CleanUp;
    }

    let TextState = 0;
    let HelpTextContent = [];
    //var TweenContext = [];
    var TweenContext = {};

    const CleanUpBounds = CleanUp.getBounds();

    //console.log(CleanUpBounds);
    //console.log(CleanUpBounds.top);

    let TextStartPoint = new Phaser.Math.Vector2(CleanUpBounds.left,CleanUpBounds.top);
    let BottomRight = new Phaser.Math.Vector2(CleanUpBounds.right,CleanUpBounds.bottom);
    let BottomLeft = new Phaser.Math.Vector2(CleanUpBounds.left,CleanUpBounds.bottom);
    let TopRight = new Phaser.Math.Vector2(CleanUpBounds.right,CleanUpBounds.top);

    BottomRight.x -= 66;
    BottomRight.y -= 45;
    BottomRight = CleanUp.pointToContainer(BottomRight);

    BottomLeft.x += 54;
    BottomLeft.y -= 45;
    BottomLeft = CleanUp.pointToContainer(BottomLeft);

    TopRight.x -= 32;
    TopRight.y += 20;
    TopRight = CleanUp.pointToContainer(TopRight);

    TextStartPoint.x += 26;
    TextStartPoint.y += 46;
    TextStartPoint = CleanUp.pointToContainer(TextStartPoint);

    //console.log(BottomRight);

    const LeftButton = Scene.addImage(BottomLeft.x,BottomLeft.y, "Hlp_Btn_Nxt",CleanUp).setDepth(Scene.DepthList.ArrowBtn);
    const RightButton = Scene.addImage(BottomRight.x,BottomRight.y, "Hlp_Btn_Nxt",CleanUp).setDepth(Scene.DepthList.ArrowBtn);
    const CancelButton = Scene.addImage(TopRight.x,TopRight.y, "Hlp_Btn_Cls",CleanUp).setDepth(Scene.DepthList.ArrowBtn);
    const CheckButton = Scene.addImage(BottomRight.x,BottomRight.y, "Sv_Btn_Chk",CleanUp).setDepth(Scene.DepthList.ArrowBtn);

    LeftButton.flipX = true;
    LeftButton.setAlpha(0);
    RightButton.setAlpha(0);
    CheckButton.setAlpha(0);

    let HelpPointerPoint = new Phaser.Math.Vector2(Scene.mid.x+50,Scene.mid.y+20);
    HelpPointerPoint = CleanUp.pointToContainer(HelpPointerPoint);

    //console.log(HelpPointerPoint);
    const HelpPointer = Scene.addImage(HelpPointerPoint.x,HelpPointerPoint.y, "Hlp_Cursor",CleanUp);

    _setTabBasedHelp();
    _leftRightCheck();
    
    const HelpText = Scene.add.text(TextStartPoint.x,TextStartPoint.y-2,HelpTextContent[0],{fontFamily: 'fulbotano',color: 0x045613, fontSize: 24}).setWordWrapWidth(430);
    HelpText.setOrigin(0,0);
    CleanUp.add(HelpText);
    
    CleanUp.setDepth(Scene.DepthList.ArrowBtn);
    HelpPopUp.setDepth(Scene.DepthList.ArrowBtn);
    HelpText.setDepth(Scene.DepthList.ArrowBtn);
    HelpPointer.setDepth(Scene.DepthList.ArrowBtn);

    const CleanUpArray = [HelpPopUp,HelpText,HelpPointer,LeftButton,RightButton,CancelButton];
    let StateCleanUp = [];

    // Scene.input.on('pointerdown',(pointer)=>
    // {
    //     let logPoint = CleanUp.pointToContainer(pointer);
    //     //console.log(logPoint);
    //     logPoint.x += (HelpPointer.width *.5);
    //     logPoint.y += (HelpPointer.height *.5);

    //     //console.log(logPoint);
    // });

    CancelButton.setInteractive();
    LeftButton.setInteractive();
    RightButton.setInteractive();
    CheckButton.setInteractive();

    RightButton.on('pointerup',()=>
    {
        Scene.AudioChan.Chan5.play('click_in_game');
        _changeState("Right");
    });

    LeftButton.on('pointerdown',()=>
    {
        Scene.AudioChan.Chan5.play('click_in_game');
        _changeState("Left");
    });

    CheckButton.once('pointerup',()=>
    {
        Scene.AudioChan.Chan5.play('click_in_game');
        CleanUp.removeAll(true);
        CleanUp.destroy();
        Scene.CleanUpHelp = "";
    });

    CancelButton.once('pointerup',()=>
    {
        Scene.AudioChan.Chan5.play('click_in_game');
        CleanUp.removeAll(true);
        CleanUp.destroy();
        Scene.CleanUpHelp = "";
    });

    function _setTabBasedHelp()
    {
        HelpPointer.setDepth(Scene.DepthList.HitBoxTree);
        let CreatedAssets;
        switch(Tab)
        {
            case 'Trees':
                HelpTextContent[0] = ABCyaPhaser.Localization.instance.getLocalizedString("tree_menu.help_text");
                _pointerMoveToTray(Scene,HelpPointer,Tab);
                break;
            case 'Grlnd':
                CreatedAssets = _prepForDraw(Tab,HelpPointer);
                HelpTextContent[0] = ABCyaPhaser.Localization.instance.getLocalizedString("garland_menu.help_text_" + (ABCyaLib.DEVICE_INFO.desktop ? "desktop" : "mobile"));
                ////console.log(_grld1);
                StateCleanUp = _pointerMoveToTray(Scene,HelpPointer,Tab,CreatedAssets);
                break;
            case 'Lts':
                CreatedAssets = _prepForDraw(Tab,HelpPointer);
                HelpTextContent[0] = ABCyaPhaser.Localization.instance.getLocalizedString("lights_menu.help_text_" + (ABCyaLib.DEVICE_INFO.desktop ? "desktop" : "mobile"));
                StateCleanUp = _pointerMoveToTray(Scene,HelpPointer,Tab,CreatedAssets);
                break;
            case 'Orn':
                HelpTextContent[0] = ABCyaPhaser.Localization.instance.getLocalizedString("ornaments_menu.help_text_" + (ABCyaLib.DEVICE_INFO.desktop ? "desktop" : "mobile"));
                _dragToTree(Scene,HelpPointer,Tab);
                break;
            case 'TreTpr':
                _movePopUp(CleanUp,508);
                HelpTextContent[0] = ABCyaPhaser.Localization.instance.getLocalizedString("tree_topper_menu.help_text_" + (ABCyaLib.DEVICE_INFO.desktop ? "desktop" : "mobile"));
                StateCleanUp = _dragToTree(Scene,HelpPointer,Tab);
                break;
            case 'Gfts':
                HelpTextContent[0] = ABCyaPhaser.Localization.instance.getLocalizedString("gifts_menu.help_text_" + (ABCyaLib.DEVICE_INFO.desktop ? "desktop" : "mobile"));
                //_pointerMoveToTray(Scene,HelpPointer,Tab);
                _dragToTree(Scene,HelpPointer,Tab);
                break;
            default:
                //console.log("error. Not A tab");
                break;
        }
    }

    async function _changeState(LeftOrRight = "Right")
    {
        if(LeftOrRight === "Right")
        {
            TextState++;    
        }
        else
        {
            TextState--;
        }
        HelpText.setText(HelpTextContent[TextState]);
        await _BetweenTweens(Scene,StateCleanUp,HelpPointer);
        _leftRightCheck();
        let NextTween = TweenContext[TextState];
        //console.log(TweenContext);
        NextTween();
    }

    function _leftRightCheck()//Sets left and right buttons to appear as needed
    {
        //console.log('Called')
        let LeftVis = false;
        let RightVis = false;
        if(HelpTextContent.length > 1)
        {
            //console.log('Called if')
            if(HelpTextContent.length === 2)
            {
                if(TextState === 0)
                {
                    RightVis = true;   
                }
                else
                {
                    LeftVis = true;
                }
            }
            else
            {
                //console.log(TextState);
                switch(TextState)
                {
                    case 0:
                        RightVis = true;
                        break;
                    case 1:
                        RightVis = true;
                        LeftVis = true;
                        break;
                    case 2:
                        LeftVis = true;
                        break;
                }
            }
        }
        if(TextState === (HelpTextContent.length - 1))
        {
            if(CheckButton.alpha === 0)
            {
                {
                    _showButton(CheckButton);
                }
            }
        }
        else
        {
            if(CheckButton.alpha === 1)
            {
                _hideButton(CheckButton);
            }
        }


        if(RightVis)
        {
            if(RightButton.alpha === 0)
            {
                _showButton(RightButton);
            }
        }
        else
        {
            if(RightButton.alpha === 1)
            {
                _hideButton(RightButton);
            }
        }
        if(LeftVis)
        {
            if(LeftButton.alpha === 0)
            {
                _showButton(LeftButton);
            }
        }
        else
        {
            if(LeftButton.alpha === 1)
            {
                _hideButton(LeftButton);
            }
        }
    }
}

function _BetweenTweens(Scene,RemoveList, HelpPointer)
{
    return new Promise((resolve)=>{
        if(RemoveList)
        {
            for(let x in RemoveList)
            {
                RemoveList[x].destroy();
            }
        }
        RemoveList = [];
        //console.log("Destroy")
        Scene.tweens.killTweensOf(HelpPointer);
        resolve('Between Tweens');
    }); 
}

function _hideButton(Button)//Used as a placeholder in case a tween is added to buttons
{
    Button.setAlpha(0);
}

function _showButton(Button)
{
    //console.log("Show");
    Button.setAlpha(1);
}

function _movePopUp(Cont,Yplacement)
{
    Cont.y = Yplacement;
}

function _pointerMoveToTray(Scene,HelpPointer,Tab,CreatedAssets)
{
    let Distance = 300;
    
    switch(Tab)
        {
            //-124,294 is default HelpPointer in container space
            case 'Trees':
                HelpPointer.setPosition(-124,342);
                break;
            case 'Grlnd':
                HelpPointer.setPosition(-124,312);
                //HelpPointer.y = 312;
                break;
            case 'Lts':
                HelpPointer.setPosition(-140,234);
                break;
            case 'TreTpr':
                HelpPointer.setPosition(-59,-182);
                //console.log(HelpPointer);
                break;
            default:
                //console.log("error. Not A tab");
                break;
            }
    let ResetPosisiton = HelpPointer.x;
    const MovePointer = Scene.addTween(HelpPointer, 500, {alpha:{start:0,to:1}},Phaser.Math.Easing.Linear,()=>{
        Scene.addTween(HelpPointer,800,{x:HelpPointer.x - Distance},Phaser.Math.Easing.Quadratic.Out,()=>{
            Scene.addTween(HelpPointer,100,{scale:.8},Phaser.Math.Easing.Quartic.InOut,()=>{
                Scene.addTween(HelpPointer,100,{scale:1,hold:200},Phaser.Math.Easing.Quadratic.InOut,()=>{
                    //HelpPointer.setScale(1);
                    
                    //MovePointer.play();
                    if(Tab === 'Grlnd' || Tab === 'Lts')
                    {
                        if(Scene.CleanUpHelp)
                        {
                            _pointerDraw(Scene,HelpPointer,Tab,CreatedAssets);
                        }
                    }
                    else
                    {
                        HelpPointer.x = ResetPosisiton;
                        MovePointer.play();
                    }
                });
            });
        });
    });
}

function _prepForDraw(Tab,HelpPointer)
{
    let ReturnAssets;
    let Scene = HelpPointer.scene;
    switch(Tab)
        {
            //-124,294 is default HelpPointer in container space
            //168, 312 in world space
            case 'Grlnd':
                //HelpPointer.x = -30;
                let Tin = [];
                Tin[0] = Scene.addImage(-40, 267-35,"Grlnd_Tnsl",HelpPointer.parentContainer).setDepth(Scene.DepthList.Buttons);
                Tin[0].setAlpha(0);
                Tin[0].setTint(0xF70D0D);
                for(let num = 1; num < 8; num++)
                {
                    Tin[num] = Scene.addImage(Tin[num-1].x + 19, Tin[0].y,"Grlnd_Tnsl",HelpPointer.parentContainer).setDepth(Scene.DepthList.Buttons);
                    Tin[num].setAlpha(0);
                    Tin[num].setTint(0xF70D0D);
                }
                ReturnAssets = Tin;
                //Tin.setScale(10);
                break;
            case 'Lts':
                //HelpPointer.x = -30;
                let Light = [];
                Light[0] = Scene.addImage(-40, 267-35,"Lt_Pnk",HelpPointer.parentContainer).setDepth(Scene.DepthList.Buttons);
                Light[0].setAlpha(0);
                for(let num = 1; num < 5; num++)
                {
                    Light[num] = Scene.addImage(Light[num-1].x + 32, Light[0].y,"Lt_Pnk",HelpPointer.parentContainer).setDepth(Scene.DepthList.Buttons);
                    Light[num].setAlpha(0);
                    //console.log(HelpPointer.parentContainer);
                }
                ReturnAssets = Light;
                break;
            default:
                //console.log("error. Not A tab");
                break;
        }
        //console.log(ReturnAssets);
        return ReturnAssets;
}

function _pointerDraw(Scene,HelpPointer,Tab,CreatedAssets)
{
    //let CreatedAssets = [];
    let Distance;
    let Delay;
    let Time;
    //HelpPointer.y = 267;
    switch(Tab)
        {
            //-124,294 is default HelpPointer in container space
            //168, 312 in world space
            case 'Grlnd':
                //HelpPointer.x = -30;
                Distance = 152;
                Delay = 64;
                Time = 512;
                //Tin.setScale(10);
                break;
            case 'Lts':
                Distance = 160;
                Delay = 96;
                Time = 480;
                break;           
            default:
                //console.log("error. Not A tab");
                break;
        }
    //HelpPointer.x = Scene.ActiveTree.getCenter().x - 40;
    let ResetPosisiton = HelpPointer.x;
    //console.log("Tween start");
    const MovePointer = Scene.addTween(HelpPointer, 500, {x:-30,y: 267},Phaser.Math.Easing.Linear,()=>{
        Scene.addTween(HelpPointer,100,{scale:{start:1,to:.8}},Phaser.Math.Easing.Quartic.InOut,()=>{
            for(let num = 0; CreatedAssets.length > num; num++)
            {
                Scene.addTween(CreatedAssets[num],2,{alpha:1,delay:num*Delay});
            }
            Scene.addTween(HelpPointer,Time,{x:HelpPointer.x + Distance,hold:400},Phaser.Math.Easing.Linear.Out,()=>{

                for(let num = 0;CreatedAssets.length > num; num++)
                {
                   CreatedAssets[num].setAlpha(0);
                }
                    //HelpPointer.x = ResetPosisiton;
                    //MovePointer.play();
                    Scene.addTween(HelpPointer,Time,{alpha:0,scale:1},Phaser.Math.Easing.Linear.Out,()=>{
                        if(Scene.CleanUpHelp)
                        {
                            _pointerMoveToTray(Scene,HelpPointer,Tab,CreatedAssets);
                        }
                    });
                });
            });
    });
}

function _garlandDrag(Scene,HelpPointer)
{
    HelpPointer.setPosition(1000,1000);
    let TempPointers = [];
    let TempObjects = [];
    let TreePoints = {Bow:{x:-18,y:179},Candle:{x: -61, y: 372},Flower:{x: 41, y: 447}};
    let ItemPoints = {Bow:{x: -512, y: 46,name: "Grlnd_Bow"},Candle:{x: -532, y: 608,name:"Grlnd_Cndl"},Flower:{x: -472, y: 608, name:"Grlnd_Flwr"}};
    let x = 0;
    let num = "Bow";
    //for(let num in ItemPoints)
    //{
        //console.log(num);
        TempPointers[x] = Scene.addImage(ItemPoints[num].x,ItemPoints[num].y,HelpPointer.frame.name,HelpPointer.parentContainer);
        TempPointers[x].setOrigin(0,0);
        TempObjects[x] = Scene.addImage(ItemPoints[num].x,ItemPoints[num].y,ItemPoints[num].name,HelpPointer.parentContainer);
        if(num === "Bow") TempObjects[x].setTint(0xF70D0D);
        Scene.addTween([TempPointers[x],TempObjects[x]],800,{x:TreePoints[num].x,y:TreePoints[num].y,repeat:-1,hold:250});
        x++;
    //}
    return TempObjects.concat(TempPointers);
}

function _dragToTree(Scene,HelpPointer,Tab,RemoveFrom = false)
{ 
    let frame;
    let CreatedAssets = [];
    let ItemDestXY;
    let PointerDestXY;
    let ItemXY;
    switch(Tab)
    {
        case "Orn":
            HelpPointer.setPosition(-415, 326);
            ItemXY = {x:-452,y:274};
            frame = "Orn_Tree";
            ItemDestXY = {x: -8, y: 185};
            PointerDestXY = {x: 32, y: 238};
            break;
        case "Gfts":
            HelpPointer.setPosition(-413, 431);
            ItemXY = {x: -454, y: 378};
            frame = "Gft9";
            ItemDestXY = {x: -194, y: 575};
            PointerDestXY = {x: -153, y: 628};
            break;
        case "TreTpr": 
            HelpPointer.setPosition(62, -319);
            ItemXY = {x: 22, y: -371};
            frame = "TreTpr6";
            ItemDestXY = {x: -245, y: -210};
            PointerDestXY = {x: -205, y: -158};
            RemoveFrom = true;
            break;

        default:
            break;
    }
    CreatedAssets[0] = Scene.addImage(ItemXY.x,ItemXY.y,frame,HelpPointer.parentContainer);
    CreatedAssets[0].setTint(0xF70D0D);
    if(!RemoveFrom)
    {
        Scene.addTween(CreatedAssets[0],800,{x: ItemDestXY.x, y: ItemDestXY.y, repeat:-1,hold:250});
        Scene.addTween(HelpPointer,800,{x: PointerDestXY.x, y: PointerDestXY.y, repeat:-1,hold:250});
    }
    else
    {
        let RepeatPointer = Scene.addTween(HelpPointer,800,{x: PointerDestXY.x, y: PointerDestXY.y,hold:240,repeat:-1},Phaser.Math.Easing.Linear.InOut,()=>
        {
    
        });
        let RepeatItem = Scene.addTween(CreatedAssets[0],800,{alpha:{start:1,to: 0},x: ItemDestXY.x, y: ItemDestXY.y,hold:240,repeat:-1},Phaser.Math.Easing.Linear.InOut,()=>
        {

        });

    }
    

    
    return CreatedAssets;
}